import type { ReactNode } from 'react';
import type { SimpleSearchFilter } from 'api/dashboard/widget';

export enum ViewType {
  ProjectList = 'PROJECT_LIST',
  ProjectTaskList = 'PROJECT_TASK_LIST',
  AllTasks = 'ALL_TASKS',
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  TimesheetReports = 'TIMESHEET_REPORTS',
  CsatReports = 'CSAT_REPORTS',
  ProjectPerformanceReports = 'PROJECT_PERFORMANCE_REPORTS',
  PeoplePerformanceReports = 'PEOPLE_PERFORMANCE_REPORTS',
  OperationReports = 'OPERATION_REPORTS',
  IntervalIqReports = 'INTERVAL_IQ_REPORTS',
  ProfitabilityReports = 'PROFITABILITY_REPORTS',
  Dashboard = 'DASHBOARD_FILTER',
  UtilizationReport = 'UTILIZATION_REPORT',
  TimesheetSubmissionReport = 'TIMESHEET_SUBMISSION_REPORT',
  UserTimeAnalyticsReport = 'USER_TIME_ANALYTICS_REPORT',
  ProjectTimeAnalyticsReport = 'PROJECT_TIME_ANALYTICS_REPORT',
  CateogryTimeAnalyticsReport = 'CATEGORY_TIME_ANALYTICS_REPORT',
}

type ViewFilterShareConfigType = {
  sharedWithCustomerPortal: boolean;
  shareWithProjects?: boolean;
  shareWithAllProjects?: boolean;
  filter?: SimpleSearchFilter;
};

export interface View<ViewDefinition> {
  viewId: number;
  viewName: string;
  viewDefinition: ViewDefinition;
  viewIcon?: ReactNode;
  createdBy: number;
  viewType: ViewType;
  self: boolean;
  viewSourceId?: number;
  viewFilterShareConfig?: ViewFilterShareConfigType;
}
